import React, {useMemo} from "react";
import {Table} from "antd";
import classnames from "classnames";
import {StringBuilder} from "../../AppUtils";
import {openWindow} from "../../http/WindowOpener.jsx";
import {createUrlWithoutTransformations} from "../../utils/cloudinaryUtils.jsx";
import "./driver-delivery-info-page.css";

export const DeliveryContentConfirmation = ({eventInfo}) => {
    const tableData = useMemo(() => {
        const isModularOrder = eventInfo?.modularProducts?.length;

        const dataSource = isModularOrder
            ? eventInfo.modularProducts.map((subProduct, index) => ({
                  key: `subproduct-${index}`,
                  amount: subProduct.amount,
                  description: (
                      <div>
                          <div>{subProduct?.name}</div>
                          {subProduct?.description && (
                              <div style={{fontSize: "12px", color: "#666", marginTop: "4px"}}>
                                  {subProduct.description}
                              </div>
                          )}
                      </div>
                  )
              }))
            : [
                  {
                      key: "main-product",
                      amount: eventInfo.productAmount || eventInfo.participants,
                      description: (
                          <div>
                              <div>
                                  <b>{eventInfo.orderName || eventInfo.productName}</b>
                              </div>
                              {eventInfo.productPackageInfo && (
                                  <div style={{fontSize: "12px", color: "#666", marginTop: "4px"}}>
                                      {eventInfo.productPackageInfo}
                                  </div>
                              )}
                          </div>
                      )
                  }
              ];

        if (eventInfo.upgradeOptions?.options?.length && isModularOrder) {
            eventInfo.upgradeOptions.options.forEach((upgradeOption, index) => {
                const amount = upgradeOption.type === "byUnit" ? upgradeOption.amount : 1;
                dataSource.push({
                    key: `upgrade-${index}`,
                    amount,
                    description: (
                        <div>
                            <div>פריט נוסף - {upgradeOption?.name}</div>
                            {upgradeOption?.description && (
                                <div style={{fontSize: "12px", color: "#666", marginTop: "4px"}}>
                                    {upgradeOption.description}
                                </div>
                            )}
                        </div>
                    )
                });
            });
        }

        if (eventInfo?.upgradeOptions?.files?.length) {
            dataSource.push({
                key: "upgrade-files",
                description: (
                    <div>
                        <div className="order-information-card-details-table-title">
                            {new StringBuilder().append("קבצים רלוונטים (לוגו, גרפיקות וכו׳)").toString()}
                        </div>
                        <div
                            className={classnames(
                                "order-information-card-details-table-desc",
                                "order-information-card-details-table-link"
                            )}
                            onClick={() =>
                                openWindow(
                                    createUrlWithoutTransformations(eventInfo?.upgradeOptions?.files?.[0]?.fileUrl)
                                )
                            }>
                            {"פתיחת קבצים רלוונטים"}
                        </div>
                    </div>
                ),
                amount: eventInfo?.upgradeOptions?.files?.length,
                pricePerUnit: "",
                totalPrice: ""
            });
        }

        return dataSource;
    }, [eventInfo]);

    const totalAmount = useMemo(() => {
        return tableData.reduce((sum, item) => sum + (item.amount || 0), 0);
    }, [tableData]);

    const columns = [
        {
            title: "תיאור",
            dataIndex: "description",
            key: "description"
        },
        {
            title: "כמות",
            dataIndex: "amount",
            key: "amount",
            width: "80px",
            align: "center"
        }
    ];

    return (
        <div className="delivery-content-confirmation">
            <Table
                className="delivery-content-confirmation-table"
                columns={columns}
                dataSource={tableData}
                pagination={false}
                summary={() => (
                    <Table.Summary.Row className="delivery-content-confirmation-summary">
                        <Table.Summary.Cell index={0} align="center">
                            <strong>סה״כ</strong>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>
                            <strong>{totalAmount}</strong>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                )}
            />
        </div>
    );
};
